import { CONTAINER_CONTAINER, DIALOG_SIZE } from "src/libs/interfaces/layouts"
import LandingFooter from "./LandingFooter"
import { Button, Popover, PopoverInteractionKind, Position } from "@blueprintjs/core"
import { __, getID } from "src/libs/utilities"
import CalloutNoExists from "src/libs/useful/CalloutNoExists"
import MeatSelectorList from "./MeatSelectorList"
import { useEffect, useState } from "react"
import { ILandingStore, useLandingStore } from "src/modules/pe-landing-module/data/store"
import { defaultSection } from "src/modules/pe-landing-module/data/defaults/defaultSection"
import { components } from "src/modules/pe-landing-module/data/utils/components"
import createMeat from "./utils/createMeat"

/* Protopia Ecosystem component */
export interface IDefaultLandingFooterProps {
   
}
const DefaultLandingFooter = (props: IDefaultLandingFooterProps): JSX.Element => {
    const [dataSize, setDataSize]   = useState<DIALOG_SIZE | undefined>( undefined )
    
    useEffect(() => useLandingStore.subscribe(
        (state: ILandingStore) => { 
            setDataSize( state.currentLanding.dataSize )
        }
    ), []) 
    
    const onNewSection = ( evt: any, key: string, n: number = 0 ) => {
        const currentLanding = useLandingStore.getState().currentLanding
        let newLanding = { ...currentLanding }
        const newSection = defaultSection()
        newLanding.sections.splice(
            n, 
            0, 
            {
                ...newSection,
                id: getID( key ),
                title: {
                    ...newSection.title,
                    text: __( components()[ key ]?.title || "New section" )
                },
                data: [
                    createMeat( key, n, {} ) 
                ],
                delimiter: { ...currentLanding.delimiter }
            }
        )
        useLandingStore.setState({ currentLanding: newLanding, needUpdate: true }) 
    } 
    return <div className="layout-app-state flex-centered ">
        <div className={ dataSize ? CONTAINER_CONTAINER[ dataSize ] : `container` }>
            <CalloutNoExists message="Page is empty" >
                <div className="p-2 flex-centered">
                    <LandingFooter />
                    <Popover 
                        position={ Position.LEFT }
                        interactionKind={ PopoverInteractionKind.CLICK }
                        content={ 
                            <MeatSelectorList onClick={onNewSection} /> 
                        } 
                        portalClassName="z-index-130" 
                        className="edit-button-popover"
                    >
                        <Button variant="minimal">
                            { __( "Create first section" ) }
                        </Button>
                    </Popover>
                </div>
            </CalloutNoExists>
        </div>
    </div>
}
export default DefaultLandingFooter